// _shared/hooks/useEventCountdown.js
import { useState, useEffect } from 'react';
import EventDateService from '../../_services/eventDateService';

// Función pura: calcula la diferencia entre ahora y la fecha del evento
const calculateCountdown = (endDate) => {
  if (!endDate) {
    return { noDate: true, expired: false, days: 0, hours: 0, minutes: 0, seconds: 0 };
  }
  const diff = new Date(endDate) - Date.now();
  if (diff <= 0) {
    return { noDate: false, expired: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
  }
  return {
    noDate: false,
    expired: false,
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000) % 24,
    minutes: Math.floor(diff / 60000) % 60,
    seconds: Math.floor(diff / 1000) % 60,
  };
};

// ==========================================
// 1) SOLO DATOS DEL EVENTO (NO tickea)
//    ✅ Seguro de usar en layouts grandes
// ==========================================
export const useEventData = (slug) => {
  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        setLoading(true);
        const data = await EventDateService.getFeaturedEventData(slug);
        if (!mounted) return;
        setEventData(data);
      } catch (err) {
        console.error('[EVENT] Error cargando datos:', err);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => { mounted = false; };
  }, [slug]);

  return { eventData, loading };
};

// ==========================================
// 2) CONTADOR QUE TICKEA cada segundo
//    ⚠️ Úsalo SOLO dentro de un componente aislado (EventCountdown)
// ==========================================
export const useCountdown = (endDate) => {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!endDate) return;
    const timer = setInterval(() => {
      setTick((t) => t + 1); // fuerza re-render solo del componente que usa este hook
      if (calculateCountdown(endDate).expired) clearInterval(timer);
    }, 1000);
    return () => clearInterval(timer);
  }, [endDate]);

  // Se calcula en cada render → siempre refleja la hora actual (sin "flash")
  return calculateCountdown(endDate);
};

// ==========================================
// 3) Hook original (compatibilidad)
//    ⚠️ NO lo uses en layouts grandes, re-renderiza todo
// ==========================================
export const useEventCountdown = (slug) => {
  const { eventData, loading } = useEventData(slug);
  const countdown = useCountdown(eventData?.endDate ?? null);
  return { loading, countdown, eventData };
};